<template>
  <div id="app">
<!--    <span style="color: #000">{{devicePixelRatio}}</span>-->
    <router-view/>
  </div>
</template>

<script>
import {scrollHide} from './util/hideElement'
import {checkToken} from '@/plugins/api/login'
import devicePixelRatio from './devicePixelRatio.js'
export default {
  name: 'App',
  created() {
    // 自适应
    // new devicePixelRatio().init()
    // 右键禁止、选中禁止
    // this.$nextTick(() => {
    //   document.oncontextmenu = new Function("event.returnValue=false")
    //   document.onselectstart = new Function("event.returnValue=false")
    // })
    // document.onkeydown = function (e) {
    //   if (e && e.keyCode === 123) {
    //     e.returnValue = false
    //     return false
    //   }
    // }
    window.addEventListener('scroll', this.hideSelect, true)
// 实时检测刷新token
  },
  mounted() {
    this.refreshToken()
    this.devicePixelRatio = window.devicePixelRatio +'--'+ window.screen.availWidth
  },
  beforeDestroy() {
    clearInterval(this.refreshTime)
    this.$nextTick(() => {
      document.oncontextmenu = new Function()
      document.onselectstart = new Function()
      window.removeEventListener('scroll', this.hideSelect, true)
    })
  },
  data() {
    return {
      // 刷新token锁
      refreshLock: false,
      // 刷新token的时间
      refreshTime: '',
      // 计时器
      timer: '',
      devicePixelRatio:1
    }
  },
  methods: {
    hideSelect() {
      scrollHide()
    },
    // 实时检测刷新token
    refreshToken() {
      this.refreshTime = setInterval(() => {
        checkToken(this.refreshTime, this.refreshLock, this.$store)
      }, 5 * 60 * 1000)
    },
  }

}
</script>

<style>
#app {
  /*min-width: 1360px;*/
  /*overflow-x: hidden;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue